module.exports = __webpack_public_path__ + "static/media/AtomizadorRotativoMini55mm.4fa5a5bb.png";